// src/pages/VietnameseTea.jsx

import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Button, Typography } from "@mui/material";
import BookForm from "../Components/BookForm/BookForm";
import Footer from "../Components/Footer/Footer";
import ProductCard from "../Components/ProductCard/ProductCard";
import Cardimg from "../Assets/vietnameseTea.png";
import vietnameseTeaMenu from "../Assets/vietnamese_tea_ceremony_menu.pdf";

const VietnameseTea = () => {
  // const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>Vietnamese Tea Ceremony (Đám Hỏi) | Dong Hung Vien Bakery</title>
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        {/* Product Information & PDF Menu Button */}
        <ProductCard
          cardImg={Cardimg}
          titleHead={
            <Typography
              variant="h2"
              sx={{
                fontWeight: "bold",
                textTransform: "uppercase",
                textAlign: { xs: "center", md: "left" },
                // MODIFICATION: Changed to a single font size for all screens
                fontSize: "35px",
              }}
            >
              VIETNAMESE TEA CEREMONY
              {' '}
              <Box component="br" sx={{ display: { xs: 'block', md: 'none' } }} />
              (ĐÁM HỎI)
            </Typography>
          }
          detailBody="A Vietnamese tea ceremony, commonly known as ‘Đám Hỏi’, is a profound blend of tradition and symbolism, celebrating not only the union of two souls but also the coming together of two families."
          detailBodyBr={
            <>
              <strong>Vietnamese Tea Ceremony Rental Policy:</strong> A $200 deposit is required to secure your Vietnamese tea ceremony rentals. This deposit will be returned in full once all rental items are returned within 48 hours of the event. If any item is not returned within that timeframe, the corresponding deposit will be forfeited. By renting our Vietnamese tea ceremony items, you agree to these terms.
            </>
          }
          ProductCardBtn={
            <Button
              sx={{ color: "#fff", fontWeight: "700", px: 3 }}
              onClick={() => {
                window.open(
                  vietnameseTeaMenu,
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              VIEW VIETNAMESE TEA CEREMONY MENU
            </Button>
          }
        />

        {/* Render the custom BookForm */}
        <BookForm />

        <Footer />
      </Box>
    </>
  );
}

export default VietnameseTea; 